import { formatAssetClassLabel, isTradedAssetClassesField } from "./tradingViewBroker";

export { formatAssetClassLabel, isTradedAssetClassesField };

export const MT4_BROKER_SLUG = "mt4";

export const MT4_DEFAULT_ASSET_CLASSES = [
  "commodity",
  "crypto",
  "energy",
  "equity",
  "fx",
  "index",
  "metal",
] as const;

export function isMt4Broker(brokerName: string | null | undefined): boolean {
  return String(brokerName || "").toLowerCase() === MT4_BROKER_SLUG;
}

/** Hidden on import — account comes from the report header (`Account:`). */
export function isMt4HiddenImportField(field: string): boolean {
  const lower = field.toLowerCase();
  return lower === "broker_name" || lower === "account_code" || lower === "account_name";
}

export function isMt4HiddenCredentialField(field: string): boolean {
  return field.toLowerCase() === "broker_name";
}

export const MT4_IMPORT_FIELD_LABELS: Record<string, string> = {
  time_zone: "Report timezone",
  traded_asset_classes: "Asset classes",
  executing_broker_name: "Executing broker",
};

export function mt4ImportFieldLabel(field: string, fallback: string): string {
  return MT4_IMPORT_FIELD_LABELS[field] ?? fallback;
}

export function buildMt4HtmlImportParams(
  values: Record<string, string>,
  assetClasses: string[]
): Record<string, string | string[]> {
  const timeZone = (values.time_zone || values.timeZone || "").trim();
  const executingBrokerName = (
    values.executing_broker_name ||
    values.executingBrokerName ||
    ""
  ).trim();
  const params: Record<string, string | string[]> = {
    broker_name: MT4_BROKER_SLUG,
    time_zone: timeZone,
    traded_asset_classes: assetClasses.map((c) => c.trim()).filter(Boolean),
  };
  if (executingBrokerName) {
    params.executing_broker_name = executingBrokerName;
  }
  return params;
}

export function isMt4HtmlFile(file: File): boolean {
  const name = file.name.toLowerCase();
  return name.endsWith(".htm") || name.endsWith(".html");
}

export function formatMt4ReconciliationWarning(
  payload: Record<string, unknown> | null | undefined
): string | null {
  if (!payload || payload.reconciliation_ok !== false) return null;
  const meta = (payload.report_meta ?? payload.reportMeta) as Record<string, unknown> | undefined;
  const summaryClosed = meta?.summary_closed_trade_pl ?? meta?.summaryClosedTradePl;
  const closedNet = meta?.closed_trade_net_sum ?? meta?.closedTradeNetSum;
  if (summaryClosed != null && closedNet != null) {
    return `Statement totals don't match imported trades (expected ${summaryClosed}, got ${closedNet}). Check the file or contact support.`;
  }
  return "Statement totals don't match imported trades. Check the file or contact support.";
}
